import { useNavigate } from "react-router-dom";
import { Shield, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import Admin from "../pages/Admin";

export default function AdminShell() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/admin");
  };

  return (
    <div className="min-h-screen grid-noise">
      <header className="sticky top-0 z-40 border-b border-amber-500/20 bg-[#0b0c14]/90 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="grid place-items-center h-8 w-8 rounded-xl bg-amber-500/15 ring-1 ring-amber-500/40 text-amber-300">
              <Shield size={17} />
            </div>
            <div className="leading-tight">
              <span className="font-display font-extrabold gold-text">{t("brand")}</span>
              <span className="ml-2 text-[10px] uppercase tracking-widest text-amber-300/80">{t("adminPanel")}</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden sm:block text-xs text-slate-400">{user?.name || user?.email}</span>
            <a href="/app" target="_blank" rel="noreferrer" data-testid="admin-view-site"
              className="grid place-items-center h-9 px-3 rounded-full border border-cyan-400/40 bg-cyan-500/10 text-cyan-300 text-xs font-bold hover:border-cyan-400 transition-colors">
              <span className="flex items-center gap-1.5"><ExternalLink size={14} /> {t("viewSite")}</span>
            </a>
            <button onClick={doLogout} data-testid="admin-logout-btn"
              className="grid place-items-center h-9 px-3 rounded-full border border-rose-400/40 bg-rose-500/10 text-rose-300 text-xs font-bold hover:border-rose-400 transition-colors">
              <span className="flex items-center gap-1.5"><LogOut size={14} /> {t("logout")}</span>
            </button>
          </div>
        </div>
      </header>
      <main className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
        <Admin />
      </main>
    </div>
  );
}
